module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2455195120/src/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main